// Message Constants
export const MESSAGES = {
  ERROR: {
    GENERIC: 'Something went wrong. Please try again.',
    NETWORK: 'Network error. Please check your connection.',
    FETCH_FAILED: 'Failed to fetch data.',
    LOAD_HISTORY: 'Failed to load booking history.',
    CREATE_PARCEL: 'Failed to create parcel.',
    PAYMENT_FAILED: 'Payment failed. Please try again.',
    FETCH_PARCELS: 'Failed to fetch parcels.',
  },
  SUCCESS: {
    PARCEL_CREATED: 'Parcel created successfully!',
    PAYMENT_COMPLETED: 'Payment completed successfully!',
    PROFILE_UPDATED: 'Profile updated successfully!',
  },
  LOADING: {
    PLEASE_WAIT: 'Please wait...',
    LOADING: 'Loading...',
    CREATING_PARCEL: 'Creating parcel...',
    PROCESSING_PAYMENT: 'Processing payment...',
  },
  EMPTY: {
    NO_BOOKINGS: 'No bookings found.',
    NO_RESULTS: 'No results found.',
    NO_ACTIVE_PARCELS: 'Your active parcels will appear here when you create a booking',
    TRY_FILTERS: 'Try adjusting your filters or search query',
  },
};

// UI Text Constants
export const UI_TEXT = {
  BOOKING_HISTORY: 'Booking History',
  PRICE_ESTIMATOR: 'Price Estimator',
  ESTIMATED_PRICE: 'Estimated Price',
  BOOK_CONSIGNMENT: 'Book Consignment',
  ENTER_DETAILS: 'Enter details to estimate',
  PICKUP_LOCATION: 'Pickup Location',
  DESTINATION: 'Destination',
  PARCEL_CATEGORY: 'Parcel Category',
  PARCEL_SIZE: 'Parcel Size',
  BOOKING_SUMMARY: 'Booking Summary',
  PAYMENT: 'Payment',
  PROFILE: 'Profile',
  WALLET: 'Wallet',
  LOGOUT: 'Logout',
};

// Validation Messages
export const VALIDATION = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Invalid email address',
  INVALID_PHONE: 'Invalid phone number',
  MIN_LENGTH: (min) => `Minimum ${min} characters required`,
  MAX_LENGTH: (max) => `Maximum ${max} characters allowed`,
};
